'use strict';

const youTube = {
	player: null,
};

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'youtube', () => ({

		done  : false,
		poster: true,
		modal : false,

		init( videoId ) {
			youTube.videoId = videoId;
			const tag = document.createElement( 'script' );
			tag.src = '//www.youtube.com/iframe_api';
			const firstScriptTag = document.getElementsByTagName( 'script' )[0];
			firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );
		},

		onPlayerReady( event ) {
			event.target.playVideo();
		},

		onPlayerStateChange( event ) {
			if ( event.data === YT.PlayerState.PLAYING && ! this.done ) {
				setTimeout( stopVideo, 6000 );
				this.done = true;
			}
		},

		stopVideo() {
			youTube.player.stopVideo();
			this.modal = false;
		},

		playVideo() {
			this.modal = true;
			youTube.player.playVideo();
		},

	}) );
});

function onYouTubeIframeAPIReady() { // eslint-disable-line no-unused-vars

	youTube.player = new YT.Player( 'video-player', {
		videoId: youTube.videoId,
		events : {
			'onReady'      : this.onPlayerReady,
			'onStateChange': this.onPlayerStateChange,
		}
	});
}
